import styled from 'styled-components';
import { Tabs } from '../Tabs';
import { Card as BaseCard } from '../atoms/Card';
import { Link as link } from '../atoms';

const BREAKPOINT = '@media(max-width: 576px)';

export const Wrapper = styled.div`
  min-height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url('/images/boarding.svg') no-repeat center center fixed;
  background-size: cover;
  flex-direction: column;
`;

export const Link = styled(link)`
  padding-top: 35px;
`;
export const LogoDesktop = styled.img`
  width: 81px;
  height: 28px;
  z-index: 2;
  position: relative;

  background: rgba(118, 62, 217, 0.4);

  ${BREAKPOINT} {
    display: none;
  }
`;

export const LogoMobile = styled.img`
  width: 81px;
  height: 28px;
  z-index: 2;
  position: relative;

  display: none;

  ${BREAKPOINT} {
    align-self: center;
    margin: auto;
    margin-bottom: 40px;
    display: block;
  }
`;

export const Card = styled(BaseCard)`
  background: ${({ theme }) => theme.colors.white};
  width: 541px;
  min-height: fit-content;
  padding-top: 32px;

  ${BREAKPOINT} {
    width: 100vw;
    min-height: 100vh;
    margin-top: 0;
  }
`;

export const SpacedTabs = styled(Tabs)`
  & .ant-tabs-nav-list {
    width: fill-available;
    justify-content: center;
    margin: 0 0 40px 0;
    overflow-x: hidden;
  }
  & .ant-tabs-tab {
    display: flex;
    flex: unset;
    justify-content: center;
    width: max-content;
    padding: 10px 0px;
    margin: 0px 20px;
    ${BREAKPOINT} {
      padding: 21px 0;
    }
  }
  & .ant-tabs-nav-more {
    display: none;
  }
  & .ant-tabs-tab-btn {
    color: ${({ theme }) => theme.colors.grey70};
  }
  & .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
    color: ${({ theme }) => theme.colors.black};
  }
`;
